import React, { useState } from "react";
import { FaUserCircle } from "react-icons/fa";
import UsendLogo from "../../../../../assets/img/logo.png";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { authSelector } from "../../../../../redux/slices/authSlice";
import { setAdminNotes } from "../../../../../redux/slices/productSlice";

export default function ExtraRequestMessages({
  product,
  adminSide
}) {
  const { loggedUser } = useSelector(authSelector);
  const dispatch = useDispatch()
  const messages = [
    {
      id: 1,
      sender: "CUSTOMER",
      customer_name: product?.user?.first_name,
      store_name: product?.store?.store_name,
      message:
        product?.quotation_request?.additional_notes?.client_note,
    },
    {
      id: 2,
      sender: "ADMIN",
      customer_name: "",
      store_name: "",
      message: (product?.quotation_request?.additional_notes?.admin_note || loggedUser?.user?.role !== "admin") &&  !adminSide? (
        product?.quotation_request?.additional_notes?.admin_note
      ) : (
        <TextField
          placeholder="Write your notes or a question..."
          multiline
          minRows={4}
          defaultValue={product?.quotation_request?.additional_notes?.admin_note}
          onChange={(e) => {
            dispatch(setAdminNotes(e.target.value));
          }}
          sx={{ width: product?.quotation_request?.additional_notes?.client_note ? "100%":"97%", }}
        />
      ),
    },
  ];

  return (
    <div>
      {messages?.filter((item) => item.message)?.map((message, index) => (
        <div>
          <div
            key={message.id}
            // ref={index === messages.length - 1 ? lastMessageRef : null}
            style={{
              borderRadius: "10px",
              marginTop: "0px",
              marginLeft: message.sender === "CUSTOMER" ? "25px" : "auto",
              marginRight: message.sender !== "CUSTOMER" ? "25px" : "auto",
              width: !product?.quotation_request?.additional_notes?.client_note ? "100%" : '50%',
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "start",
                textAlign: "left",
              }}
            >
              <div>
                {message.sender === "CUSTOMER" && product?.quotation_request?.additional_notes?.client_note? (
                  product?.user?.img ? (
                    <img
                      src={product?.user?.img}
                      alt="logo"
                      style={{
                        objectFit: "cover",
                        width: "35px",
                        height: "35px",
                        marginRight: "15px",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <FaUserCircle
                      style={{
                        marginRight: "15px",
                        fontSize: "30px",
                        color: "#60717e",
                      }}
                    />
                  )
                ) : (
                  <img
                    src={UsendLogo}
                    alt="logo"
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "cover",
                      marginRight: "10px",
                    }}
                  />
                )}
              </div>

              <div style={{ width: "100%" }}>
                <>
                {message.sender === "CUSTOMER" && product?.quotation_request?.additional_notes?.client_note ? (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <b style={{ color: "#60717e", fontSize: "14px" }}>
                      {message.customer_name + "-" + message.store_name}
                    </b>{" "}
                  </div>
                ) : (
                  <h5
                    style={{
                      color: "#60717e",
                      fontSize: "14px",
                      marginTop: "10px",
                    }}
                  >
                    Team - U-Send Fulfillment
                  </h5>
                )}
                </>

                <h6
                  style={{
                    lineHeight: 1.5,
                    marginTop: "5px",
                    marginBottom: 0,
                  }}
                >
                  {" "}
                  {message.message}
                </h6>

                
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
